<script>
import ReviewLink from '@/views/LKMunMeh/Review/components/LKMunMehReviewLink.vue'

export default {
  name: 'LKMunMehReviewSecondLink',
  extends: ReviewLink,
  // На случай возможного расширения: если компонент будет отличаться от формы оценивания экспертом 1 уровня.
}
</script>
